import { useParams } from "react-router-dom";
import { ProjectLazy } from "./ProjectLazy";

// One editor mount per board: Project's refs (e.g. useAutoOpenMatchedProducts'
// one-shot flag, EditLockProvider's lock path) are scoped to a single id, and
// Back/Forward over SaveButton's pushState can change :id in place. A switch
// of SaveButton to navigate() would make every first save remount the editor.
export const BoardRoute = () => {
  const { id } = useParams();
  return <ProjectLazy key={id} />;
};
